import {  FETCH_EXPENSES, LOG_OUT_USER } from "../../actions/actionTypes";


const fetchExpensesSummaryReducer = (summary, payload) => {
    summary = [];
    for(let s of payload){
        summary.push(s);
    }
    return summary;
}

const expensesSummaryReducer = (state=[], action) => {
    let summary = state;
    if (action && action.summary && !action.payload.errors && action.type === FETCH_EXPENSES){
        summary = fetchExpensesSummaryReducer(summary, action.summary);
    } else if (action.type === LOG_OUT_USER){
        summary = [];
    }

    return summary;
}

export default expensesSummaryReducer;